module.exports = __webpack_public_path__ + "static/media/access_lock.2ca75bfb.svg";